import React from 'react';

import {
    withStyles,
    Grid,
    Button,
    AppBar,
    Toolbar,
    ButtonBase,
    Tabs,
    Tab,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import PreviewTwoItem from '../view/PreviewTwoItem';
import MBack from '../view/MBack';
import MSectionHeader from '../view/MSectionHeader';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import MAnchor from '../view/MAnchor';
import AppData from '../../model/AppData';
import MTabPanel from '../view/MTabPanel';
import { MatchItem } from '../match/view';
import AnchorItem from './AnchorItem';
import MTabsButton from '../view/MTabsButton';
import MNoLiving from '../view/MNoLiving';
import MStatusBar from '../view/MStatusBar';
import TabIndicator from '../view/TabIndicator';



class SearchDialog extends React.Component {
    constructor(props) {
        super(props);

        let keys = [];
        let historyKey = AppUtils.getStorageObj(AppUtils.REARCH_HISTORY);
        if (historyKey && historyKey.length > 0) {
            keys = historyKey;
        }

        this.state = {
            historyKey: keys,
            hotKey: [],
            live: [],
            host: [],
            value: 0,
            pageNum: 1,
            search_title: '',
            searchLabel: '',
            nowHostRecomm: [],
            changeIndex: 0,
            TabTexts: ['全部', '主播', '赛程', '直播'],
            anchorData: [],
            matchData: [],
            liveData: [],
            typeValue: 0,
        };

    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'SearchDialog');
        this.getHostSearch();
        this.getHotRearch();
        this.getRecommAnchor();
        this.getLiving();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getHotRearch = async () => {
        let { hotKey } = this.state;
        let result = await Apis.encryptionHotSearch();
        if (result.code == 200) {
            let data = result.data;
            data = data.sort((a, b) => {
                return b.sort - a.sort;
            })
            for (let i = 0; i < data.length; i++) {
                hotKey.push(data[i].title);
            }
        }
        this.setState({ hotKey: hotKey });
    }

    getRecommAnchor = async () => {
        let host = [];
        let hostResult = await Apis.encryptionHostRecomm();
        if (hostResult.code == 200) {
            host = hostResult.data;
        }
        let nowHostRecomm = [];
        for (let i = 0; i < host.length && i < 4; i++) {
            nowHostRecomm.push(host[i]);
        }
        this.setState({ host: host, nowHostRecomm: nowHostRecomm });
    }

    getLiving = async () => {
        let result = await Apis.encryptionHostLive();
        console.log('getLiving', result);
        if (result.code == 200) {
            this.setState({ live: result.data });
        }
    }

    getHostSearch = async () => {
        let { search_title, historyKey } = this.state;
        if (search_title != '') {
            let isExast = false;
            for (let i = 0; i < historyKey.length; i++) {
                if (historyKey[i] == search_title) {
                    isExast = true;
                }
            }
            if (!isExast) {
                historyKey.push(search_title)
            }

            let anchorData = [];
            let liveData = [];
            let result = await Apis.encryptionHostSearch(search_title);
            console.log('encryptionHostSearch', result);
            if (result.code == 200) {
                if (result.data.host && result.data.host.length > 0) {
                    anchorData = result.data.host;
                }
                if (result.data.live && result.data.live.length > 0) {
                    liveData = result.data.live;
                }
            }

            let matchData = [];
            result = await Apis.encryptionSearchMatch(search_title);
            console.log('encryptionSearchMatch', result);
            if (result.code == 200) {
                matchData = result.data;
            }
            this.setState({ historyKey: historyKey, matchData: matchData, anchorData: anchorData, liveData: liveData, searchLabel: search_title });
            AppUtils.setStorageObj(AppUtils.REARCH_HISTORY, historyKey);
        } else {
            this.setState({ searchLabel: search_title });
        }
    }

    _onClickChip = (search_title) => {
        this.state.search_title = search_title;
        this.getHostSearch();
    }

    _onChangeValue(value) {
        this.setState({ searchLabel: value });
    }

    _onSearchClick(e) {
        if (e.keyCode === 13) {
            const { searchLabel } = this.state;
            this.state.search_title = searchLabel;
            this.getHostSearch();
        }
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    _onDel = () => {
        this.state.historyKey = [];
        this.state.search_title = '';
        this.getHostSearch();
    }

    _handleChange = () => {
        let { changeIndex, host } = this.state;
        let hostRecomm = host;

        changeIndex++;
        if (changeIndex * 4 >= hostRecomm.length) {
            changeIndex = 0;
        }
        let nowHostRecomm = [];
        let startIdx = changeIndex * 4;
        for (let i = startIdx; i < hostRecomm.length && i < startIdx + 4; i++) {
            nowHostRecomm.push(hostRecomm[i]);
        }
        this.setState({ nowHostRecomm: nowHostRecomm, changeIndex: changeIndex });
    }

    _handleTab = (val) => {
        this.setState({ value: val });
    }

    _onSubmit = (e) => {
        e.preventDefault();
    }

    _handleTypeChange = (v) => {
        this.setState({ typeValue: v });
    }

    renderHistory = () => {
        const { classes } = this.props;
        const { historyKey, hotKey, live, nowHostRecomm } = this.state;
        let lives = AppUtils.processList(live, 2);
        return (
            <Grid container direction='column' className={classes.root}>
                <Grid style={{ width: '100%' }}>
                    <MSectionHeader title={'历史搜索'} subtitle=' ' chevron={false} del={true} onClick={() => this._onDel()} />
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 8, paddingRight: 8 }}>
                        {
                            historyKey.map((item, i) => (
                                <ButtonBase key={i} onClick={() => this._onClickChip(item)} className={classes.buttonChip}>{item}</ButtonBase>
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%' }}>
                    <MSectionHeader title={'热门搜索'} subtitle='' chevron={false} />
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 8, paddingRight: 8 }}>
                        {
                            hotKey.map((item, i) => (
                                <ButtonBase key={i} onClick={() => this._onClickChip(item)} className={classes.buttonChip}>{item}</ButtonBase>
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%' }}>
                    <MSectionHeader title={'推荐主播'} subtitle='换一换' chevron={false} onClick={() => this._handleChange()} />
                    <Grid container direction='row' justify='flex-start' wrap='wrap' style={{ width: '100%' }}>
                        {
                            nowHostRecomm.map((item, i) => (
                                <Grid key={i} container alignItems='center' style={{ maxWidth: '20vw', marginLeft: 8, marginRight: 8, marginBottom: 16 }}>
                                    <MAnchor
                                        key={i}
                                        data={item}
                                        showsbsb={true}
                                        name={item.nickName}
                                        avatar={item.portrait}
                                        sbusb={AppData.isStarAnchor(item.user_id)}
                                        onClick={() => this._onClicAnchor(item)} />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%' }}>
                    <MSectionHeader title={'热门直播'} subtitle='' chevron={false} />
                    <Grid container direction='column' style={{ width: '100%' }}>
                        {
                            lives.length > 0 && lives.map((item, i) => (
                                <PreviewTwoItem key={i} data={item} />
                            ))
                        }
                        {
                            lives.length == 0 && <Grid container direction='column' style={{ marginTop: 32 }}>
                                <MNoLiving />
                            </Grid>

                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderTabs = () => {
        const { TabTexts, value } = this.state;
        return (
            <Grid container direction='column' style={{ padding: 0 }}>
                <Grid container alignItems='center' justify='center' style={{ backgroundColor: '#FFF', width: '100%', height: 32 }}>
                    <Tabs
                        value={value}
                        variant='fullWidth'
                        onChange={(e, val) => this._handleTab(val)}
                        TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                        style={{ minHeight: 32, width: '100vw' }}
                    >
                        {
                            TabTexts.map((item, i) => (
                                <Tab key={i} label={item} style={{ color: value == i ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }}></Tab>
                            ))
                        }
                    </Tabs>
                </Grid>
            </Grid>
        );
    }

    renderSearch = () => {
        const { classes } = this.props;
        const { anchorData, matchData, liveData, value, typeValue } = this.state;
        let matchs = [];
        for (let i = 0; i < matchData.length; i++) {
            if (matchData[i].type_id == typeValue + 1) {
                matchs.push(matchData[i]);
            }
        }
        let lives = AppUtils.processList(liveData, 2);
        return (
            <Grid container direction='row' className={classes.list} >
                <MTabPanel value={value} index='0' style={{ width: '100%' }}>
                    {
                        liveData.length > 0 && <MSectionHeader title={'相关直播'} subtitle='' chevron={false} />
                    }
                    {
                        lives.map((item, i) => (
                            <PreviewTwoItem key={i} data={item} />
                        ))
                    }
                    {
                        anchorData.length > 0 && <MSectionHeader title={'相关主播'} subtitle='' chevron={false} />
                    }
                    {
                        anchorData.map((item, i) => (
                            <AnchorItem
                                key={i}
                                name={item.nickname}
                                fans={item.fans_number}
                                avatar={item.portrait}
                                sbusb={AppData.isStarAnchor(item.user_id)}
                                onClick={() => this._onClicAnchor(item)}
                            />
                        ))
                    }
                    {
                        matchData.length > 0 && <MSectionHeader title={'相关赛程'} subtitle='' chevron={false} />
                    }
                    {
                        matchData.map((item, i) => (
                            <MatchItem key={i} line={true} data={item} />
                        ))
                    }
                </MTabPanel>
                <MTabPanel value={value} index='1' style={{ width: '100%', marginTop: 0 }}>
                    {
                        anchorData.map((item, i) => (
                            <AnchorItem
                                key={i}
                                name={item.nickname}
                                fans={item.fans_number}
                                avatar={item.portrait}
                                sbusb={AppData.isStarAnchor(item.user_id)}
                                onClick={() => this._onClicAnchor(item)}
                            />
                        ))
                    }
                </MTabPanel>
                <MTabPanel value={value} index='2' style={{ width: '100%', marginTop: 0 }}>
                    <Grid container style={{ marginTop: 16, marginBottom: 8 }}  >
                        <MTabsButton data={['足球', '篮球']} onChange={(v) => this._handleTypeChange(v)} />
                    </Grid>
                    {
                        matchs.map((item, i) => (
                            <MatchItem key={i} line={true} data={item} />
                        ))
                    }
                </MTabPanel>
                <MTabPanel value={value} index='3' style={{ width: '100%', marginTop: 16 }}>
                    {
                        lives.map((item, i) => (
                            <PreviewTwoItem key={i} data={item} />
                        ))
                    }
                </MTabPanel>
            </Grid>
        );
    }

    // 账号安全
    render() {
        const { classes } = this.props;
        const { searchLabel, search_title } = this.state;
        return (
            <MBack HeaderComponent={
                <AppBar className={classes.appbar}>
                    <MStatusBar />
                    <Toolbar style={{ justifyContent: 'center', alignItems: 'center', paddingLeft: 8, margin: 0, paddingRight: 8 }}>
                        <Grid container justify='space-between' alignItems='center' style={{ width: '100vw' }}>
                            <Grid container alignItems='center' className={classes.searchInputBg} >
                                <form action="" style={{ lineHeight: 1.5, width: '100%' }} onSubmit={(e) => this._onSubmit(e)}>
                                    <input
                                        type='search'
                                        value={searchLabel}
                                        onChange={(e) => this._onChangeValue(e.target.value)}
                                        onKeyUp={(e) => this._onSearchClick(e)}
                                        className={classes.searchInput} placeholder='搜索主播/比赛/联赛/房间号' />
                                </form>
                            </Grid>
                            <Button disableRipple style={{
                                paddingLeft: 0,
                                paddingRight: 0,
                                marginRight: 0,
                                marginLeft: 0,
                                minWidth: 32,
                            }} onClick={() => window.history.back()}>取消</Button>
                        </Grid>
                    </Toolbar>
                    {
                        search_title != '' && this.renderTabs()
                    }
                </ AppBar>
            }>
                {
                    search_title == '' && this.renderHistory()
                }
                {
                    search_title != '' && this.renderSearch()
                }
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(0, 0, 0, 0),
        marginTop: 48,
    },
    buttonChip: {
        backgroundColor: '#F2F2F2',
        borderRadius: 12.5,
        height: 25,
        color: '#0D0D0D',
        padding: theme.spacing(0.5, 1, 0.5, 1),
        margin: theme.spacing(0.5, 0.5, 0.5, 0.5),
        fontSize: 12,
        fontWeight: 500,
    },
    searchInputBg: {
        backgroundColor: '#F3F3F3',
        borderRadius: 15,
        flex: 1,
        height: 32,
        padding: theme.spacing(0, 1, 0, 1),
        margin: theme.spacing(0, 1, 0, 0),
    },
    searchInput: {
        border: 'none',
        outline: 'none',
        color: '#0D0D0D',
        flex: 1,
        width: '100%',
        height: 24,
        backgroundColor: 'transparent',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
        fontSize: theme.typography.pxToRem(12),
        webkitInputPlaceholder: {
            color: '#0D0D0D',
            fontSize: theme.typography.pxToRem(12),
        },
        mozPlaceholder: {
            color: '#0D0D0D',
            fontSize: theme.typography.pxToRem(12),
        },
        msInputPlaceholder: {
            color: '#0D0D0D',
            fontSize: theme.typography.pxToRem(12),
        },
    },
    appbar: {
        backgroundColor: '#FFF',
        flexDirection: 'rows',
        boxShadow: '1px 1px 3px #F0F0F0',
        marginTop: 0,
    },
    list: {
        padding: theme.spacing(0, 0, 0, 0),
        marginTop: theme.spacing(0),
        backgroundColor: '#FFF',
        marginTop: 80,
    },

}))(SearchDialog));